import { useEffect, useState } from 'react';
import styles from '@components/ContentNavigation/ContentNavigation.styles';
import ErrorBoundary from '@components/errors/ErrorBoundary';
import theme from '@styles/theme';
import Icon from '@components/icons/Icon';
import Button from '@components/Button/Button';
import { IContentNavigation } from '@features/cms/typescript';
import ContentNavigationLinks from '@components/ContentNavigation/ContentNavigationLinks/ContentNavigationLinks';
import layoutUiState from '@features/layout/mobX/LayoutUiState';
type PropTypes = {
  links: IContentNavigation[];
};
const ContentNavigation = ({
  links
}: PropTypes) => {
  const [isTriggered, setIsTriggered] = useState(false);
  const [isVisible, setIsVisible] = useState(false);
  const [layoutBarsTotalHeight, setLayoutBarsTotalHeight] = useState(0);
  const {
    getLayoutFixedBarsHeight
  } = layoutUiState;
  let timer: NodeJS.Timeout;
  const handleStickyBar = () => {
    if (window.scrollY > window.innerHeight) {
      setIsVisible(true);
      setIsTriggered(true);
    } else {
      setIsVisible(false);
    }
    setLayoutBarsTotalHeight(getLayoutFixedBarsHeight());
  };
  useEffect(() => {
    window.addEventListener('scroll', handleStickyBar);
    timer = setInterval(() => handleStickyBar(), 100);
    return () => {
      window.removeEventListener('scroll', handleStickyBar);
      clearTimeout(timer);
    };
  }, []);
  const handleScrollUp = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };
  if (!isTriggered) {
    return <></>;
  }
  return <ErrorBoundary>
      <nav sx={styles.stickyNav(isVisible, layoutBarsTotalHeight)} data-cy="StickyBar" className="navigationStickyBar">
        <div sx={styles.stickyLeftBox}>
          <Button variant="iconOnly" onClick={handleScrollUp}>
            <Icon icon="NavigationBack" color={theme.rawColors.darkGrey700} size="24px" cy="ArrowBackBold" />
          </Button>
        </div>
        <ContentNavigationLinks links={links} />
      </nav>
    </ErrorBoundary>;
};
export default ContentNavigation;